import React, { useContext, useState } from 'react'
import { Content, CriteriaRow, Label, Title } from '../../core/screen-util'
import { UnitSelectionContext, ErrorContext, SpinContext } from 'context'
import { Button, message, Select } from 'antd'
import {
  getApiTargetInfo,
  getUserName,
  UnitSelection,
  isValidYearRange,
  getValidYearRange,
} from 'core'
import moment from 'moment'
import { JcTmpErrorTable } from '../../core/component/JcTmpErrorDialog'
import R from 'ramda'
import {
  netCapVerificationDataExport,
  netCapVerificationDataCheckExport,
  exportData,
} from 'api/pgads'
import { connect } from 'react-redux'
const NetCapacityVerificationExport = ({
  targetInfo,
  userName,
  validYearRange,
}) => {
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { setSpinning, spinning } = useContext(SpinContext)
  const [showCreateButton, setShowCreateButton] = useState(true)
  const { setError } = useContext(ErrorContext)
  const curYear = parseInt(moment().format('YYYY'))
  const [startYear, setStartYear] = useState(curYear)
  const [endYear, setEndYear] = useState(curYear)
  const [errorData, setErrorData] = useState([])

  const checkData = _ => {
    if (selectedUnits.length <= 0) {
      message.warn('Please, Select Unit(s)')
      setVisibleUnitSelection(true)
      return
    }

    const isValid = isValidYearRange(
      validYearRange,
      moment(startYear + '-01-01'),
      moment(endYear + '-12-31')
    )
    if (!isValid) return

    setSpinning(true)
    netCapVerificationDataCheckExport(targetInfo)({
      startYear: startYear,
      endYear: endYear,
      unitIds: selectedUnits.map(u => u.unitId),
    }).fork(setError, err => {
      setSpinning(false)
      setShowCreateButton(false)
      setErrorData(err)
      if (err.length <= 0) {
        exportVerificationData()
      }
    })
  }

  const exportVerificationData = _ => {
    if (selectedUnits.length <= 0) {
      message.warn('Please, Select Unit(s)')
      setVisibleUnitSelection(true)
      return
    }
    const isValid = isValidYearRange(
      validYearRange,
      moment(startYear + '-01-01'),
      moment(endYear + '-12-31')
    )
    if (!isValid) return

    setSpinning(true)
    netCapVerificationDataExport(targetInfo)({
      startYear: startYear,
      endYear: endYear,
      unitIds: selectedUnits.map(u => u.unitId),
    }).fork(setError, data => {
      setSpinning(false)
      setShowCreateButton(true)
      const blobData = new Blob(
        [
          R.join(
            '\r\n',
            data.map(d => d.lineData)
          ),
        ],
        { type: 'text/csv' }
      )
      exportData(
        blobData,
        'text/csv',
        'VerificationExport_' +
          userName +
          '_' +
          moment().format('YYYY-MM-DDTHH-mm-ss') +
          '.csv'
      )
      setErrorData([])
    })
  }

  const onAbort = _ => {
    setShowCreateButton(true)
    setErrorData([])
  }

  return (
    <React.Fragment>
      <UnitSelection disabled={!showCreateButton} setData={onAbort} />
      <CriteriaRow style={{ columnGap: '5px' }}>
        <Title>Net Capacity Verification Data Export</Title>
        <Label>From :</Label>
        <Select value={startYear} onChange={year => setStartYear(year)}>
          {R.range(curYear - 15, curYear + 3).map(y => (
            <Select.Option value={y} key={y}>
              {y}
            </Select.Option>
          ))}
        </Select>
        <Label>To :</Label>
        <Select value={endYear} onChange={year => setEndYear(year)}>
          {R.range(curYear - 15, curYear + 3).map(y => (
            <Select.Option value={y} key={y}>
              {y}
            </Select.Option>
          ))}
        </Select>
        <Button
          onClick={checkData}
          type="primary"
          disabled={!showCreateButton}
          icon="file-add"
          loading={spinning}
        >
          Create File
        </Button>
        <Button
          onClick={exportVerificationData}
          type="primary"
          disabled={showCreateButton}
          icon="caret-right"
          loading={spinning}
        >
          Continue
        </Button>
        <Button
          type="danger"
          onClick={onAbort}
          disabled={showCreateButton}
          icon="stop"
          loading={spinning}
        >
          Abort
        </Button>
      </CriteriaRow>
      <Content>
        <JcTmpErrorTable errors={errorData} scroll={{ y: 600 }} />
      </Content>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  userName: getUserName(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(NetCapacityVerificationExport)
